/**
 * Root Component
 */
import React from 'react';
import PropTypes from 'prop-types';
import { Provider } from 'react-redux';
import { useRoutes } from 'react-router-dom';
import IntlWrapper from './modules/Intl/IntlWrapper';
import { ConfigProvider } from 'react-avatar';

import { routes } from './routes';

// Base stylesheet
require('./main.scss');

export default function App({ store }) {
  const content = useRoutes(routes);

  return (
    <Provider store={store}>
      <IntlWrapper>
        {/* _variables.scss brand colours under white initials: 4.62:1 ($moonstone-700) to 10.27:1 ($primary) */}
        <ConfigProvider colors={[
          '#004080',
          '#2262A2',
          '#028190',
          '#0A5B63',
          '#40555C',
          '#AC4747',
          '#545D66',
        ]}>
          {content}
        </ConfigProvider>
      </IntlWrapper>
    </Provider>
  );
}

App.propTypes = {
  store: PropTypes.object.isRequired,
};
